import { render } from "./EqRecordConfigZhiZaoEdit.vue?vue&type=template&id=0065d924&scoped=true"
import script from "./EqRecordConfigZhiZaoEdit.vue?vue&type=script&lang=js"
export * from "./EqRecordConfigZhiZaoEdit.vue?vue&type=script&lang=js"

import "./EqRecordConfigZhiZaoEdit.vue?vue&type=style&index=0&id=0065d924&scoped=true&lang=css"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/joysun-ems/joysun-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0065d924"]])

export default __exports__